var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    rx: 1,
    fill: "#35313F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    width: 19.2,
    height: 19.2,
    rx: 1,
    fill: "#35313F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 28.8,
    width: 19.2,
    height: 19.2,
    rx: 1,
    fill: "#35313F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.8,
    y: 28.8,
    width: 19.2,
    height: 19.2,
    rx: 1,
    fill: "#35313F"
  })));
}

export default SvgCards;